import {combineReducers} from 'redux'
import types from 'actions/types'

const trackedRoutes = (state = {}, action) => {
  switch (action.type) {
    case types.TRACK_ROUTE:
      return {
        ...state,
        [action.key]: action.route,
      }
    case types.UN_TRACK_ROUTES:
      return {}
    default:
      return state
  }

}
export default combineReducers({
  trackedRoutes,
})
